import { TFunction } from "i18next";

import { FormConfigField, FormValues } from "@/types/DynamicForm.type";

export const productFormDefinition = (t: TFunction) =>
  [
    {
      fieldType: "header",
      label: t("predictive.product.questionnaire.HEADER.label"),
      description: t("predictive.product.questionnaire.HEADER.description"),
    },
    {
      fieldType: "warning",
      label: t("predictive.product.questionnaire.WARNING.label"),
      description: t("predictive.product.questionnaire.WARNING.description"),
    },
    {
      name: "name",
      fieldType: "input",
      label: t("predictive.product.questionnaire.NAME.label"),
      placeholder: t("predictive.product.questionnaire.NAME.placeholder"),
      rules: { required: t("predictive.product.questionnaire.NAME.rules.required") },
    },
    {
      name: "DESCRIPTION",
      fieldType: "textarea",
      placeholder: t("predictive.product.questionnaire.DESCRIPTION.placeholder"),
      rules: { required: t("predictive.product.questionnaire.DESCRIPTION.rules.required") },
      target: "DESCRIPTION",
    },
    {
      name: "USPS",
      fieldType: "textarea",
      placeholder: t("predictive.product.questionnaire.USPS.placeholder"),
      helperText: t("predictive.product.questionnaire.USPS.helperText"),
      rules: { required: t("predictive.product.questionnaire.USPS.rules.required") },
      target: "USPS",
    },
    {
      name: "FEATURES_SERVICES",
      fieldType: "textarea",
      placeholder: t("predictive.product.questionnaire.FEATURES_SERVICES.placeholder"),
      target: "FEATURES_SERVICES",
      isOptional: true,
    },
    {
      name: "COMPETING_TOOLS",
      fieldType: "input",
      placeholder: t("predictive.product.questionnaire.COMPETING_TOOLS.placeholder"),
      target: "COMPETING_TOOLS",
      isOptional: true,
    },
  ] as const satisfies readonly FormConfigField[];

type ProductFormDefinition = ReturnType<typeof productFormDefinition>;
export type ProductFormValues = FormValues<ProductFormDefinition>;
